import React, { useState } from "react";
import * as Bananas from "bananas-commerce-admin";

import { Button } from "@mui/material";

import { useSnackbar } from "notistack";

import { PublishingRuleCreateSchema } from "../types";

import EditScheduleDialog from "./EditScheduleDialog";

export interface SchedulesActionBarProps {
  refresh: () => void;
}

const SchedulesActionBar: React.FC<SchedulesActionBarProps> = ({ refresh }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const api = Bananas.useApi();
  const { t } = Bananas.useI18n();
  const { enqueueSnackbar } = useSnackbar();
  const handleSubmit = async (data: PublishingRuleCreateSchema) => {
    const response = await api.operations[
      "mediahouse.publishing-rule:new"
    ]?.call({ body: data });

    if (response?.status === 200) {
      enqueueSnackbar("Utgivningsschemat har skapats");
    }

    refresh();
  };
  return (
    <Bananas.ActionBar>
      <EditScheduleDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSubmit={handleSubmit}
      />
      <Button variant="outlined" onClick={() => setDialogOpen(true)}>
        {t("Lägg till schema")}
      </Button>
    </Bananas.ActionBar>
  );
};

export default SchedulesActionBar;
